module.exports = __webpack_public_path__ + "img/game-cinematic.2dfa2e85.webp";